export default function ($rootScope, $timeout, $parse, $q) {
    var slice = Array.prototype.slice;
    return {
        restrict: 'A',
        require: '?ngModel',
        scope: false,
        link($scope, $element, attrs, ngModel) {
            var isInputTypeFile = $element[0].tagName.toLowerCase() === 'input' && attrs.type && attrs.type.toLowerCase() === 'file';
            var onFileReaderLoading = attrs.onFileReaderLoading && $parse(attrs.onFileReaderLoading);
            var onFileReaderLoaded = attrs.onFileReaderLoaded && $parse(attrs.onFileReaderLoaded);
            var onTextReady = attrs.onTextReady && $parse(attrs.onTextReady);
            var onImageReady = attrs.onImageReady && $parse(attrs.onImageReady);
            var isReading = attrs.isReading && $parse(attrs.isReading);

            if (ngModel) ngModel.$render = function () { };

            if (attrs.fileReader) {
                $scope[attrs.fileReader] = {
                    read: readFile
                };
            }

            $element.bind('change', function (changedEvent) {
                var element = changedEvent.target;
                if (isReading) isReading.assign($scope, true);
                $rootScope.$emit('fileReaderLoading', { event: changedEvent });
                if (onFileReaderLoading) onFileReaderLoading($scope, { $files: element.files });


                //let it breathe
                $timeout(function () {
                    $q.all(slice.call(element.files, 0).map(readFile))
                        .then(function (values) {
                            if (ngModel) {
                                if (element.multiple) ngModel.$setViewValue(values);
                                else ngModel.$setViewValue(values.length ? values[0] : null);
                            }
                            if (isReading) isReading.assign($scope, false);
                            $rootScope.$emit('fileReaderLoaded', { file: values[0], files: values });
                        });
                }, 20);

            }); //change

            function readFile(file) {
                if (Array.isArray(file)) return $q.all(file.map(f => readFile(f)));
                var deferred = $q.defer();
                if (file) {
                    var fr = new FileReader();
                    fr.onload = function (e) {
                        // $scope.$apply(function () { });
                        $rootScope.$emit('fileReaderLoaded', { event: e, target: e.target, result: e.target.result });
                        if (onFileReaderLoaded) onFileReaderLoaded($scope, { $file: file, $event: e, $target: e.target, $result: e.target.result });
                        if (onTextReady) onTextReady($scope, { $file: file, $text: e.target.result, $event: e, $target: e.target, $result: e.target.result });
                        if (onImageReady) onImageReady($scope, { $file: file, $dataUrl: e.target.result, $event: e, $target: e.target, $result: e.target.result });
                        deferred.resolve(e.target.result);
                        //fr.onload = fr.onerror = null;
                    };
                    fr.onerror = function (e) {
                        deferred.reject(e);
                        //fr.onload = fr.onerror = null;
                    };
                    if (onTextReady) fr.readAsText(file);
                    else if (onImageReady) fr.readAsDataURL(file);
                } else {
                    deferred.reject('no file');
                }
                return deferred.promise;
            }//readFile

        } //link
    }; //return
};